import { render, staticRenderFns } from "./LinkAdClusterAndAds.vue?vue&type=template&id=23043648&scoped=true&"
import script from "./LinkAdClusterAndAds.vue?vue&type=script&lang=js&"
export * from "./LinkAdClusterAndAds.vue?vue&type=script&lang=js&"
import style0 from "./LinkAdClusterAndAds.vue?vue&type=style&index=0&id=23043648&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23043648",
  null
  
)

export default component.exports